var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPaginationArrowLeftDouble(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 11,
    viewBox: "0 0 12 11",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.24051 10.4051L0 5.20253L5.24051 0L6 0.759494L1.51899 5.20253L6 9.64557L5.24051 10.4051Z",
    fill: "#666E7D"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.2405 10.4051L6 5.20253L11.2405 0L12 0.759494L7.51899 5.20253L12 9.64557L11.2405 10.4051Z",
    fill: "#666E7D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPaginationArrowLeftDouble);
export default __webpack_public_path__ + "static/media/pagination-arrow-left-double.cdded28d95461d08e87101008faf7dbd.svg";
export { ForwardRef as ReactComponent };